var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from 'react'; // tslint:disable-line
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { formFieldId } from '../utils/form-field-id';
import { useLang } from '../hooks/use-lang';
import { FieldDescription } from './field-description';
import { Icon } from '../elements/icon';
import { Loader } from '../elements/loader';
import { HTML } from '../elements/html';
import { Badge } from '../elements/badge';
import { ExclamationIcon } from '@shapeable/icons';
export var FieldLabelDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    line-height: 1em;\n    \n    b {\n      color: ", ";\n    }\n  "], ["\n    font-size: ", ";\n    color: ", ";\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    line-height: 1em;\n    \n    b {\n      color: ", ";\n    }\n  "])), theme.FONT_SIZE(13), theme.COLOR('text-chrome'), theme.COLOR('primary')),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(14))
});
var FieldDescriptionStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.COLOR('text-subtle'))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    text-transform: uppercase;\n    font-size: 13px;\n    color: ", ";\n    align-items: center;\n  "], ["\n    text-transform: uppercase;\n    font-size: 13px;\n    color: ", ";\n    align-items: center;\n  "])), theme.COLOR('text-subtle')),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    align-items: center; \n  "], ["\n    align-items: center; \n  "])))
});
var LabelAndLoaderStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 4px;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 4px;\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    width: 16px;\n    height: 16px;\n    margin-right: ", ";\n\n  "], ["\n    ", ";\n    width: 16px;\n    height: 16px;\n    margin-right: ", ";\n\n  "])), theme.FILL('error'), theme.UNIT(2))
});
var BadgeStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.label(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  FieldDescription: styled(FieldDescription)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), FieldDescriptionStyles),
  LabelAndLoader: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LabelAndLoaderStyles),
  Loader: styled(Loader)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Icon: styled(Icon)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Badge: styled(Badge)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
export var FieldLabel = function (props) {
  var className = props.className,
    field = props.field;
  var t = useLang();
  if (!field) {
    return null;
  }
  var label = field.label,
    description = field.description,
    required = field.required,
    loadingMessage = field.loadingMessage,
    disabled = field.disabled,
    badge = field.badge;
  var valid = field.valid === undefined ? true : !!field.valid;
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.LabelAndLoader, null, React.createElement(My.Label, {
    htmlFor: formFieldId(field)
  }, !valid && React.createElement(My.Icon, null, React.createElement(ExclamationIcon, null)), t(label), required && React.createElement(My.Badge, null, t('Required')), field.badge && React.createElement(My.Badge, null, field.badge), !required && badge && !disabled && React.createElement(My.Badge, null, badge)), loadingMessage && React.createElement(My.Loader, {
    spaceUnits: 1.5
  }, t(loadingMessage))), !disabled && description && React.createElement(My.FieldDescription, {
    field: field
  }, React.createElement(HTML, {
    text: t(description),
    allowedTags: ['br', 'strong', 'b', 'em', 'i']
  })));
};
FieldLabel.defaultProps = FieldLabelDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;